import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Finalize from './Finalize';
import FinalizeByUsername from './FinalizeByUsername';
import Default from './Default';

function App() {
  return (
   <Router>
       <Routes>
           <Route path="/sms/*" element={<FinalizeByUsername/>}/>
           <Route path="/finalize/*" element={<Finalize/>}/>
           <Route path="*" element={<Default/>}/>
       </Routes>
   </Router>
  );
}
export default App;